import { render, staticRenderFns } from "./TrasferimentiMagazzino.vue?vue&type=template&id=5b19de6b&"
import script from "./TrasferimentiMagazzino.vue?vue&type=script&lang=js&"
export * from "./TrasferimentiMagazzino.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports